import React from 'react';
import './LoadingIcon2.css';

const loadingImage = 'https://cdn.obsess-vr.com/ferragamo/loading.gif'

const LoadingIcon2 = () => 
     (
    <div align="center" className="cssload-fond" id="loadingIcon">       
        <img src= {loadingImage} height="80px" />
    </div>
    )

export default LoadingIcon2; 
